import { AtlasBounds, AtlasPosition } from '../../mu-atlas/interfaces/mu-atlas-types.interface';

declare var L;

export class MuMapLeafletBounds implements AtlasBounds {
  private bounds: any;

  constructor(position?: AtlasPosition) {
    this.bounds = L.latLngBounds();
    if (position) {
      this.extend(position);
    }
  }

  extend(position: AtlasPosition): void {
    this.bounds.extend(position);
  }

  getCenter(): AtlasPosition {
    return this.bounds.getCenter();
  }

  getNorthEast(): AtlasPosition {
    return this.bounds.getNorthEast();
  }

  getSouthWest(): AtlasPosition {
    return this.bounds.getSouthWest();
  }
}
